import adminRoutes from "emun.admin/admin.states";
import basicController from "servicestack/basic.controller.properties";

export default class AdminContainerController {
  constructor($element) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.navs = adminRoutes.map((nav) => ({
      ...this.$state.get(nav.name),
      ...nav,
    }));
    Object.assign($ctrl, {
      $element,
      adminRoutes,
    });
    console.debug("AdminContainerController", $ctrl);
  }

  isVisible() {
    const $ctrl = this;
    return $ctrl.navs.some((n) => $ctrl.$state.current.name.startsWith(n.name));
  }
}
